// extracted by mini-css-extract-plugin
export default {"closeButton":"PolicyPreviewModal_closeButton__FbUW0","pdfViewer":"PolicyPreviewModal_pdfViewer__nSl+u"};